var inProgress = {};
var dataWebpackPrefix = "(function universalModuleDefinition(exportedModule) {\n  // Для server-sider отрисовки.\n  if (typeof Graal !== 'undefined') {\n    // eslint-disable-next-line guard-for-in,no-restricted-syntax\n    for (const i in exportedModule) {\n      exports = exportedModule;\n    }\n  } else {\n    // Для браузера.\n    // eslint-disable-next-line no-undef\n    window.reactTagsRegistry = Object.assign(window.reactTagsRegistry || {}, exportedModule.tags);\n    // eslint-disable-next-line no-undef\n    window.reactTagsChunksRegistry = Object.assign(window.reactTagsChunksRegistry || {}, exportedModule.lazyChunks);\n  }\n}):";
// loadScript function to load a script via script tag
__webpack_require__.l = function(url, done, key, chunkId) {
	if(inProgress[url]) { inProgress[url].push(done); return; }
	var script, needAttach;
	if(key !== undefined) {
		var scripts = document.getElementsByTagName("script");
		for(var i = 0; i < scripts.length; i++) {
			var s = scripts[i];
			if(s.getAttribute("src") == url || s.getAttribute("data-webpack") == dataWebpackPrefix + key) { script = s; break; }
		}
	}
	if(!script) {
		needAttach = true;
		script = document.createElement('script');

		script.charset = 'utf-8';
		script.timeout = 120;
		if (__webpack_require__.nc) {
			script.setAttribute("nonce", __webpack_require__.nc);
		}
		script.setAttribute("data-webpack", dataWebpackPrefix + key);

		script.src = url;
	}
	inProgress[url] = [done];
	var onScriptComplete = function(prev, event) {
		// avoid mem leaks in IE.
		script.onerror = script.onload = null;
		clearTimeout(timeout);
		var doneFns = inProgress[url];
		delete inProgress[url];
		script.parentNode && script.parentNode.removeChild(script);
		doneFns && doneFns.forEach(function(fn) { return fn(event); });
		if(prev) return prev(event);
	}
	var timeout = setTimeout(onScriptComplete.bind(null, undefined, { type: 'timeout', target: script }), 120000);
	script.onerror = onScriptComplete.bind(null, script.onerror);
	script.onload = onScriptComplete.bind(null, script.onload);
	needAttach && document.head.appendChild(script);
};